import { type DataConnectorOpenaiModel } from "@doitintl/cmp-models";
import { Box } from "@mui/material";

import { FilterTable } from "../../../../../Components/FilterTable/FilterTable";
import { FilterTableSkeleton } from "../../../../../Components/FilterTable/FilterTableSkeleton";
import { filters, headerColumns } from "./OpenAIAssetColumns";
import OpenAIAssetRow, { type OpenAIAssetRowData } from "./OpenAIAssetRow";

const OpenAIAssetTable = ({ configs }: { configs: ReadonlyArray<DataConnectorOpenaiModel> }) => {
  const rowWrapper = ({ row }: { row: OpenAIAssetRowData }) => <OpenAIAssetRow data={row} />;

  return (
    <Box
      sx={{
        mb: 4,
      }}
    >
      {configs === undefined ? (
        <FilterTableSkeleton />
      ) : (
        <FilterTable<OpenAIAssetRowData>
          tableItems={configs}
          rowComponent={rowWrapper}
          headerColumns={headerColumns}
          filterColumns={filters}
          persistenceKey="OpenAIAssetTable"
          data-cy="OpenAIAssetTable"
        />
      )}
    </Box>
  );
};

export default OpenAIAssetTable;
